module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"placeholder":"mer. 1/01/30","passport_number":"Numéro de passeport","expiration-date":"Date d\u0027expiration","emission-country":"Pays d\u0027émission","errors":{"required":"Champ requis"}},"en":{"placeholder":"Wen. 1/01/30","passport_number":"Passport number","expiration-date":"Expiration date","emission-country":"Emission country","errors":{"required":"Required field"}}}')
  delete Component.options._Ctor
}
